import type {
    ParsedDataRow,
    ResolverJobResults,
    SupportRequestResultsResponse,
} from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';

export const transformResolverResults = (data: ResolverJobResults['data']) => {
    const { columns, rows } = data;

    const jobResults = rows.map((row) => {
        const item: ParsedDataRow = {};
        columns.forEach((col, index) => {
            item[col] = row[index];
        });
        return item as SupportRequestResultsResponse;
    });

    return jobResults;
};
